// extracted by mini-css-extract-plugin
export default {"scan":"style_scan__5XLCv","close":"style_close__cZxPB","scanner":"style_scanner__fdHWm","info":"style_info__K-6LA","buttons":"style_buttons__ddEJr"};